<template>
    <button class="btn-answer-check">
        <span class="btn-answer-check__text">KONTROL</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {};
</script>

<style scoped src="@/css/components/btn-answer-check.css"></style>